import React, { useMemo } from 'react';

import { useAppSelector } from '../../../../hooks/react-redux';
import { HomePageChart } from '../../../auth/login/store/types';
import { MAX_PIE_SEGMENTS } from '../../../constants/analytics';
import { OfficeBuilding } from '../../../shared/icons';
import { getEntitySpreadAnalytics, getFetchingAnalytics } from '../../store';
import { ChartLoading } from '../ChartLoading';
import { PieChartWrapper } from '../PieChartWrapper';

interface EntitySpreadChartProps {
    dimensions?: {
        height: number;
        width: number;
    }
    analyticsSpinner: boolean;
}

export const EntitySpreadChart: React.FC<EntitySpreadChartProps> = ({ dimensions, analyticsSpinner }) => {
    const entitySpreadAnalytics = useAppSelector(getEntitySpreadAnalytics);
    const fetchingAnalytics = useAppSelector(getFetchingAnalytics);
    const showSpinner = useMemo(() => fetchingAnalytics.includes(HomePageChart.ENTITY_SPREAD) || analyticsSpinner, [fetchingAnalytics, analyticsSpinner]);

    const chartLabel = useMemo(() => entitySpreadAnalytics.length > MAX_PIE_SEGMENTS ? `Top ${MAX_PIE_SEGMENTS} Counterparties` : 'Counterparties', [entitySpreadAnalytics.length]);

    if (showSpinner) {
        return <ChartLoading dimensions={dimensions} />;
    }

    return (
        <PieChartWrapper
            data={entitySpreadAnalytics}
            dimensions={dimensions}
            icon={OfficeBuilding}
            testId='homepage-entity-spread'
            colors='oceanFrench'
            label={chartLabel}
        />
    );
};
